<div
  *ngIf="isVisible()"
  class="solution-area"
  role="region"
  [attr.aria-labelledby]="isSolutionHeaderVisible() ? getHeaderId() : null"
  [attr.aria-label]="isSolutionHeaderVisible() ? null : getText('lbl_solution')"
  (mouseenter)="audioTrigger.next(true)"
>
  <div  class="solution-container">
    <div class="solution-header" *ngIf="isSolutionHeaderVisible()" [id]="getHeaderId()">
      <tra slug="lbl_correct_answer"></tra><tra slug="txt_colon"></tra>
    </div>
    <div *ngFor="let contentElement of element.content" (click)="openZoomInModal()" style="cursor: pointer;">
      <element-render
        [contentElement]="contentElement" 
        [questionState]="questionState" 
        [isLocked]="isLocked"
        [questionPubSub]="questionPubSub"
      ></element-render>
    </div>

  </div>
</div>
<render-audio
[url]="element.voiceover?.url || ''"
[trigger]="audioTrigger"
[isTriggerDisabled]="!isVoiceoverEnabled()"
></render-audio>


<span id="customModalSolutionBlockWrapper">
    <div id="customModalSolutionBlock" class="custom-modal" [ngClass]="cModal()?.type" *ngIf="cModal()">
      <div [ngSwitch]="cModal()?.type" class="modal-contents">
        <div *ngSwitchCase="Modal.POP_UP_CONTENT">
          <div *ngFor="let contentElement of element.content">
            <element-render
              [contentElement]="contentElement" 
              [questionState]="questionState" 
              [isLocked]="isLocked"
            ></element-render>
          </div>
          <modal-footer [pageModal]="pageModal" [isConfirmAlert]="false" ></modal-footer>
        </div>
      </div>
    </div>
</span>